import SEOPageTemplate from '../components/SEOPageTemplate';

const ChauffeurAlbany = () => (
  <SEOPageTemplate
    city="Albany"
    state="NY"
    route="/chauffeur-albany-ny"
    imageSrc="/albany-ny-limo.jpg"
    introduction="In Albany, New York's capital city, TiLimousine provides a transportation service that understands the unique demands of this government and business hub. Our chauffeurs are intimately familiar with Albany's distinctive character, from the historic Empire State Plaza to the bustling business districts. Whether you're visiting the State Capitol, attending a conference at the Convention Center, or exploring the city's growing tech sector, our service ensures your journey through Albany is conducted with the professionalism and efficiency that this important city deserves."
    testimonial={{
      quote: "As a state government lobbyist, I need reliable transportation that understands Albany's unique political landscape. TiLimousine's chauffeurs know every government building and legislative office, making my meetings across the capital region seamless and efficient.",
      author: "Robert M.",
      role: "Senior Government Affairs Director, Albany Policy Group"
    }}
    services={[
      'Luxury chauffeur service for airport transfers and FBO pickup',
      'Executive car service and black car service for business travel',
      'Hourly chauffeur hire and as-directed black car service',
      'Private driver service for events, weddings, and VIPs',
      'Long-distance city-to-city rides: Albany ⇄ NYC, Albany ⇄ Boston',
      'Professional chauffeur company for meetings and corporate events',
      'Livery service and luxury livery transportation',
      'Town car service and car and driver rental',
      'Book a chauffeur in Albany',
      'Best chauffeur in New York',
      'Chauffeured transportation for VIPs',
      'Luxury car with driver',
      'Business travel car service',
      'Limo vs black car service Albany',
      'Best executive car service in Albany',
      'FBO pickup with luxury car',
      'Chauffeur for meetings and corporate events'
    ]}
    airports={[
      'Albany International Airport (ALB)',
      'Signature Flight Support',
      'Atlantic Aviation',
      'Teterboro Airport (TEB)',
      'JFK',
      'LGA',
      'Logan International Airport (BOS)',
      'Bradley International Airport (BDL)'
    ]}
    neighborhoods={[
      'Empire State Plaza',
      'Downtown Albany',
      'Center Square',
      'Lark Street',
      'Warehouse District',
      'Hudson/Park',
      'Pine Hills',
      'New Scotland',
      'Delaware Avenue',
      'Menands',
      'Colonie',
      'Greater Albany Area'
    ]}
  />
);

export default ChauffeurAlbany; 